import { ThemeType } from "@intelligems/ig-types/schemas/organization";
import { createSlice } from "@reduxjs/toolkit";
import { IThemesState } from "@src/store/slices/themes/types";

const initialState: IThemesState = {
  themes: [],
};

const slice = createSlice({
  name: "themes",
  initialState,
  reducers: (create) => ({
    initThemes: create.reducer<ThemeType[]>((state, action) => {
      state.themes = action.payload;
    }),
  }),
  selectors: {
    getThemes: (state) => state.themes,
  },
});

export const { initThemes } = slice.actions;
export const { getThemes } = slice.selectors;

export const themesReducer = slice.reducer;
